module.exports = __webpack_public_path__ + "img/pin_exchange_red.e3cef134.svg";